import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/pfc";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function NewsletterUnsubscribe() {
  const { token } = useParams();
  const [state, setState] = useState({ status: "loading", email: null });

  useEffect(() => {
    api.get(`/newsletter/unsubscribe/${token}`)
      .then((r) => setState({ status: "unsubscribed", email: r.data.email }))
      .catch(() => setState({ status: "invalid", email: null }));
  }, [token]);

  return (
    <div className="max-w-[700px] mx-auto px-5 lg:px-10 py-24 text-center" data-testid="newsletter-unsub-page">
      {state.status === "loading" && (
        <>
          <Loader2 className="mx-auto text-pfc-gold animate-spin mb-6" size={48} />
          <p className="label text-pfc-gold">Processing…</p>
        </>
      )}
      {state.status === "unsubscribed" && (
        <div data-testid="newsletter-unsubbed">
          <CheckCircle2 className="mx-auto text-white/60 mb-6" size={64} />
          <div className="label text-white/60 mb-3">Done</div>
          <h1 className="font-display text-4xl text-white uppercase"><span className="gold-text">{state.email}</span> has been removed.</h1>
          <p className="text-white/60 mt-6 font-body">You won’t receive any more PFC newsletter emails. Sorry to see you go.</p>
          <Link to="/" className="inline-block mt-8 font-sub uppercase tracking-[0.25em] text-sm px-8 py-4 border border-white/20 text-white hover:border-pfc-gold transition">
            Back to Home
          </Link>
        </div>
      )}
      {state.status === "invalid" && (
        <div data-testid="newsletter-unsub-invalid">
          <XCircle className="mx-auto text-pfc-red mb-6" size={64} />
          <div className="label text-pfc-red mb-3">Invalid Link</div>
          <h1 className="font-display text-3xl text-white uppercase">This unsubscribe link is no longer valid.</h1>
        </div>
      )}
    </div>
  );
}
